import React from "react";
import NavBar from "../general/navBar";
import logo from "../../assets/img/logo.svg";

const Hero = () => {
  return (
    <section className="hero-section">
      <NavBar />
      <article className="content">
        <h1>Agileom, l’intérim réinventé</h1>
        <p>
          Une alliance entre expertise terrain et innovation digitale
          <br /> pour une gestion simplifiée de vos missions.
        </p>
        <svg
          className="bottom-curve"
          viewBox="0 0 1440 150"
          preserveAspectRatio="none"
        >
          <path
            fill="#ffffff"
            d="M0,0 C480,150 960,150 1440,0 L1440,150 L0,150 Z"
          />
        </svg>
      </article>
      <img className="bg-logo" src={logo} />
      <div></div>
    </section>
  );
};

export default Hero;
